import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Blessing {
  id: number;
  name: string;
  relationship: string;
  message: string;
  date: string;
}

const DisplayedBlessings = () => {
  const blessings: Blessing[] = [
    {
      id: 1,
      name: "Winny AKOT",
      relationship: "Close Friend",
      message: "Watching your love story unfold has been such a blessing. Your commitment to God and each other is truly inspiring. May your marriage be filled with endless joy, unwavering faith, and abundant love. Praying for a lifetime of happiness together!",
      date: "January 20, 2024"
    },
    {
      id: 2,
      name: "Elder Thomas Kuol",
      relationship: "Church Member",
      message: "As you begin this sacred journey, remember that a cord of three strands is not easily broken. Keep Christ at the center of your marriage, honor your cultural heritage, and always communicate with love and respect. God bless your union abundantly.",
      date: "January 18, 2024"
    },
    {
      id: 3,
      name: "Maria Santos",
      relationship: "Family Member",
      message: "Gloria, you have found a man who loves God and honors family. Moyak, you have found a woman of grace and strength. Together, you will build something beautiful. May God's favor rest upon your marriage and may you always find joy in each other.",
      date: "January 15, 2024"
    },
    {
      id: 4,
      name: "Salva Kiir Mayaardit",
      relationship: "Other",
      message: "Your story reminds us that God's timing is always perfect. We pray that your marriage will be a testimony of His faithfulness, a source of strength in difficult times, and a celebration of love in all seasons. Congratulations and many blessings!",
      date: "January 12, 2024"
    }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Community Blessings
          </h2>
          <p className="font-inter text-lg text-muted-foreground max-w-2xl mx-auto">
            Heartfelt messages from our loved ones
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {blessings.map((blessing) => (
            <div 
              key={blessing.id}
              className="bg-card rounded-lg p-6 shadow-sacred-md hover:shadow-sacred-lg transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-start space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full flex-shrink-0">
                    <Icon name="UserIcon" size={20} className="text-primary" />
                  </div>
                  <div>
                    <h4 className="font-playfair text-lg font-semibold text-foreground">
                      {blessing.name}
                    </h4>
                    <p className="font-inter text-xs text-muted-foreground">
                      {blessing.relationship}
                    </p>
                  </div>
                </div>
                <Icon name="HeartIcon" size={20} className="text-accent" variant="solid" />
              </div>
              
              <p className="font-inter text-sm text-foreground leading-relaxed mb-4">
                {blessing.message}
              </p>
              
              <div className="flex items-center space-x-2 text-muted text-xs">
                <Icon name="CalendarIcon" size={14} />
                <span className="font-inter">{blessing.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="font-inter text-sm text-muted-foreground mb-4">
            Want to add your blessing to this collection?
          </p>
          <a 
            href="#blessing-form"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground font-inter text-sm font-medium rounded-lg hover:bg-primary/90 transition-all duration-200"
          >
            <Icon name="PencilSquareIcon" size={18} />
            <span>Share Your Blessing</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default DisplayedBlessings;